import React from "react";
import { Avatar, Popover } from "antd";
import { useAuth } from "../../authentication";
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';

const UserProfile = () => {
  const { authUser, userSignOut } = useAuth();
  const history = useHistory();

  const onLogoutClick = () => {
    userSignOut(() => {
      history.push('/');
    });
  }

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>
        <div><b>{authUser.FirstName} {authUser.LastName}</b></div>
        <div className="silver">{authUser.Email}</div>
        <div className="silver">{authUser.Client.Name}</div>
      </li>
      <li onClick={() => { history.push('/my-profile'); }}>My Profile</li>
      <li onClick={onLogoutClick}>Logout</li>
    </ul>
  );

  return (
    <div className="gx-flex-row gx-align-items-center gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <Avatar className="gx-size-40 gx-pointer gx-mr-3" alt="">{globalFunction.getAvatarName(authUser.FirstName + ' ' + authUser.LastName)}</Avatar>
        <span className="gx-avatar-name"><i className="icon icon-chevron-down gx-fs-xxs" /></span>
      </Popover>
    </div>
  )
};

export default UserProfile;
